import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import {
    ResetPasswordFormWrapper,
    SetNewPasswordBtnWrapper,
} from 'src/domains/players/webview/components/Account/resetPasswordProcedure/resetPasswordForm/ResetPasswordForm.style';
import { ResetPasswordFormState } from 'src/domains/players/webview/components/Account/resetPasswordProcedure/resetPasswordForm/ResetPasswordForm.state';
import { Input } from 'src/domains/players/webview/components/form/input/Input';
import { ResetPasswordRhsRouteType } from 'src/domains/layouts/state/router/newRouter/rhsRouteType';
import { ResetPasswordSuccessfullyChange } from './ResetPasswordSuccessfullyChange';
import { AlignBottomWrapper } from 'src/domains/players/webview/components/Account/forgotPasswordTab/ForgotPasswordTab.style';
import { AccountHelperInfo } from 'src/domains/players/webview/components/Account/component/accountHelperInfo/AccountHelperInfo';
import { AccountHelperContainer } from 'src/domains/players/webview/components/Account/forgotPasswordTab/resetPasswordSent/ResetPasswordSent.style';
import { Messages } from 'src/domains/layouts/webview/components/Messages/Messages';
import { useCommon } from 'src/domains/common/Common';
import { StarRouter } from 'src/domains/layouts/state/router/StarRouter';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { AccountState } from 'src/domains/players/shared/Types';

interface PropsType {
    currentRoute: ResetPasswordRhsRouteType;
}

export const ResetPasswordForm = observer('ResetPasswordForm', (props: PropsType) => {
    const { currentRoute } = props;
    const common = useCommon();

    const accountState = AccountState.get(common);
    const starRouter = StarRouter.get(common);
    const configComponents = ConfigComponents.get(common);
    const [resetPasswordState] = useState(
        () => new ResetPasswordFormState(starRouter, configComponents, true, false, accountState)
    );

    const errors = (
        <>
            {resetPasswordState.errors.map((message, i) => (
                <span key={i}>{message}</span>
            ))}
        </>
    );

    if (resetPasswordState.isSuccess) {
        return <ResetPasswordSuccessfullyChange />;
    }

    return (
        <AccountHelperContainer>
            <ResetPasswordFormWrapper
                onSubmit={(e): void => {
                    e.preventDefault();
                }}
            >
                <Input
                    name='password'
                    type={resetPasswordState.isShowPassword ? 'text' : 'password'}
                    label={
                        <I18n
                            langKey='account.reset-password.new-password.label'
                            defaultText='New password'
                        />
                    }
                    state={resetPasswordState.newPasswordState}
                    isShowPassword={resetPasswordState.isShowPassword}
                    showPassword={resetPasswordState.setShowPassword}
                    showPasswordFlag={true}
                    showSuccessIcon={resetPasswordState.newPasswordState.result.value.type === 'ok'}
                    autocomplete='off'
                    colorTheme='light'
                    dataTest='new-password-input'
                />
                <Input
                    name='confirm'
                    type={resetPasswordState.isShowConfirmPassword ? 'text' : 'password'}
                    label={
                        <I18n
                            langKey='account.reset-password.confirm-password.label'
                            defaultText='Confirm password'
                        />
                    }
                    state={resetPasswordState.confirmPasswordState}
                    isShowPassword={resetPasswordState.isShowConfirmPassword}
                    showPassword={resetPasswordState.setShowConfirmPassword}
                    showSuccessIcon={resetPasswordState.confirmPasswordState.result.value.type === 'ok'}
                    showPasswordFlag={true}
                    autocomplete='off'
                    colorTheme='light'
                    dataTest='confirm-password-input'
                />
                {resetPasswordState.errors.length > 0 ? (
                    <Messages
                        type='error'
                        marginBottom='16px'
                        message={errors}
                    />
                ) : null}
                <SetNewPasswordBtnWrapper
                    disabled={resetPasswordState.isFormValid === false}
                    onClick={(): Promise<void> => resetPasswordState.onSubmit(currentRoute)}
                    size='large'
                    type='submit'
                    isError={resetPasswordState.isConfirmPassError}
                    dataTest='set-new-password-button'
                >
                    <I18n
                        langKey='account.reset-password.submit.label'
                        defaultText='Set new password'
                    />
                </SetNewPasswordBtnWrapper>
            </ResetPasswordFormWrapper>
            <AlignBottomWrapper>
                <AccountHelperInfo />
            </AlignBottomWrapper>
        </AccountHelperContainer>
    );
});
